import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import moment from 'moment';
import _ from 'lodash';
import Header from '../../components/Header';
import Planned from '../../components/Product/Planned';
import Selected from '../../components/Product/Selected';
import { onGoBack, sortData } from '../../common/globals';
import withGoBack from '../../common/withGoBack';
import {
  getTableCaseByCaseId,
  getProductDescriptionById,
  updateTableCaseByPrimaryId
} from '../../utils/db';
import {
  listSingleCase,
  updateCase,
  updateACMProduct
} from '../../utils/utils';
import withOnline from '../../common/withOnline';
import withLoader from '../../common/withLoader';
import withNotify from '../../common/withNotify';
import withTableName from '../../common/withTableName';
import ACMProductGoBackModal from '../../components/Models/ACMProductGoBackModal';
import Bugsnag from '../../helpers/bugsnag';
import ACMSelectedProduct from '../../components/Models/ACMSelectedProduct';
import SelectProduct from '../../components/Models/SelectProduct';

class AcmProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPlannedSelect: true,
      selectedData: [],
      plannedData: {},
      caseRes: {},
      selectedProduct: {},
      saveEnable: '',
      caseData: {}
    };
    this.acmProductGoBackModal = null;
    this.acmSelectedProduct = null;
  }

  componentDidMount() {
    try {
      this.acmProductGoBackModal = new window.bootstrap.Modal(window.$('#acmProductGoBackModal'));
      this.acmSelectedProduct = new window.bootstrap.Modal(window.$('#acmSelectedProduct'));
      this.selectProductModal = new window.bootstrap.Modal(window.$('#selectProductModal'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickSave = async () => {
    try {
      const { caseRes } = this.state;
      const {
        online, setLoader, notify, params: { id }, goBack, setGoBack
      } = this.props;

      const parts = {
        Parts: (caseRes.ACMSelectedParts !== null) ? caseRes.ACMSelectedParts.split(';') : null
      };
      if (online) {
        setLoader(true);
        updateACMProduct(caseRes.CaseScheduleID, parts).then(async (response) => {
          setLoader(false);
          const { status, message } = response;
          if (status) {
            if (message.length > 0) {
              // notify({ type: 'success', message });
            }
            await updateCase(caseRes);
            if (goBack.length >= 2 && goBack[goBack.length - 2].indexOf(`manage-case/${id}`) > -1) {
              // TODO Remove all state and set only /manage-cases
              setGoBack(['/manage-cases']);
              // setGoBack(goBack.splice(goBack.length - 2, 1));
              browserHistory.push(`/manage-case/${id}`);
            } else if (goBack.length === 2) {
              onGoBack(goBack);
            } else {
              browserHistory.push('/manage-cases');
            }
          } else {
            notify({ type: 'error', message });
          }
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectProducts = () => {
    try {
      const { params: { id } } = this.props;
      this._onGoBack();
      browserHistory.push(`/manage-case/${id}/acm-products/select`);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onDelete = async (selectedData) => {
    try {
      const { caseRes } = this.state;
      const { tableName } = this.props;
      const values = caseRes.ACMSelectedParts.split(';');
      const index = values.indexOf(selectedData.productId);
      if (index > -1) {
        values.splice(index, 1);
      }
      caseRes.ACMSelectedParts = caseRes.ACMSelectedParts !== '' ? values.join(';') : null;
      caseRes.Sync = 1;
      await updateTableCaseByPrimaryId(caseRes.id, caseRes, tableName);
      await this._getACMSelectedParts();
      await this._onSaveEnable();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getAMCPlannedParts = async () => {
    try {
      const { params: { id }, tableName } = this.props;
      const plannedArr = [];
      const caseRes = await getTableCaseByCaseId(id, tableName);

      if (caseRes && caseRes.ACMPlannedParts !== null) {
        const ACMPlannedArray = caseRes.ACMPlannedParts.split(';');
        ACMPlannedArray.map((value) => {
          plannedArr.push(value.split(','));
        });

        const plannedValue = plannedArr.slice(0).map(
          ([productId, bodyComponent, confidence, isTemplated]) => (
            {
              productId,
              bodyComponent,
              confidence,
              isTemplated
            }
          )
        );

        const sortPlannedValue = sortData(plannedValue, 'bodyComponent');
        for await (const value of sortPlannedValue) {
          const productRes = await getProductDescriptionById(value.productId);
          value.ProductDescription = productRes;
          value.confidence = Math.round(value.confidence * 100);
        }
        const plannedData = {};
        const promisePlanedValue = sortPlannedValue.map((item) => new Promise((resolve) => {
          if (!plannedData.hasOwnProperty(item.bodyComponent)) {
            plannedData[item.bodyComponent] = [];
          }
          plannedData[item.bodyComponent].push(item);
          resolve(true);
        }));

        await Promise.all(promisePlanedValue);
        if (plannedData.length > 0) {
          Object.keys(plannedData).map((data) => {
            const maxValue = Math.max(...plannedData[data].map((o) => o.confidence));
            plannedData[data].map((value) => {
              value.maxValue = maxValue;
            });
          });
        }
        this.setState({
          plannedData, caseRes
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getACMSelectedParts = async () => {
    try {
      const { params: { id }, tableName } = this.props;
      const selectedArr = [];
      const caseRes = await getTableCaseByCaseId(id, tableName);
      if (caseRes && caseRes.ACMSelectedParts !== null) {
        const ACMSelectedArray = caseRes.ACMSelectedParts !== []
          ? caseRes.ACMSelectedParts.split(';') : [];

        // const newArray = selectedArr.filter((value) => JSON.stringify(value) !== '[""]');
        // const newArray = selectedArr.filter((value) => Object.keys(value).length !== 0);
        ACMSelectedArray.map(async (value) => {
          selectedArr.push({ productId: value });
        });
        for await (const value of selectedArr) {
          const productRes = await getProductDescriptionById(value.productId);
          value.ProductDescription = productRes;
        }
        this.setState({
          selectedData: selectedArr,
          caseRes
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onACMProductGoBack = async () => {
    try {
      const { goBack, notify, setLoader } = this.props;
      const { caseRes } = this.state;
      setLoader(true);
      const singleCaseRes = await listSingleCase(caseRes.CaseScheduleID);
      setLoader(false);
      const newData = Object.keys(caseRes).length > 0
        && caseRes.ACMSelectedParts !== null ? caseRes.ACMSelectedParts.split(';') : null;
      const { message, status, data } = singleCaseRes;
      if (status) {
        const oldData = data !== undefined && data[0].ACMSelectedParts !== null ? data[0].ACMSelectedParts.split(';') : null;
        if (JSON.stringify(newData) === JSON.stringify(oldData)) {
          this.acmProductGoBackModal.hide();
          onGoBack(goBack);
        } else {
          this.acmProductGoBackModal.show();
        }
      } else {
        notify({ type: 'error', message });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCancel = async () => {
    try {
      const {
        goBack, params: { id }, tableName, setLoader
      } = this.props;
      const { caseRes } = this.state;
      let singleCaseRes = {};
      setLoader(true);
      singleCaseRes = await listSingleCase(caseRes.CaseScheduleID);
      setLoader(false);
      const oldData = singleCaseRes.data[0];
      setLoader(true);
      await updateCase(oldData);
      setLoader(false);
      await updateTableCaseByPrimaryId(Number(id), oldData, tableName);
      await this._getACMSelectedParts();
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onAddSelectedProduct = async (data) => {
    try {
      const { selectedData } = this.state;
      // const { params: { id }, tableName } = this.props;
      if (selectedData.length >= 10) {
        this.acmSelectedProduct.show();
        return;
      }
      this.selectProductModal.show();
      this.setState({
        selectedProduct: data
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSave = async () => {
    try {
      const { caseRes, selectedProduct } = this.state;
      const { params: { id }, tableName } = this.props;
      let selectedValue = caseRes.ACMSelectedParts;
      if (selectedValue !== null) {
        selectedValue += `${(caseRes.ACMSelectedParts === null)
          ? selectedProduct.productId : `;${selectedProduct.productId}`}`;
      } else {
        selectedValue = selectedProduct.productId;
      }
      caseRes.ACMSelectedParts = selectedValue;
      await updateTableCaseByPrimaryId(Number(id), caseRes, tableName);
      await this._getACMSelectedParts();
      await this._onSaveEnable();
      this.selectProductModal.hide();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onAcmFlagDetails = async () => {
    try {
      const { params: { id } } = this.props;
      this._onGoBack();
      browserHistory.push(`/manage-case/${id}/acm-products/acmFlagDetails`);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSaveEnable = async () => {
    try {
      const { notify, setLoader } = this.props;
      const { caseRes } = this.state;
      setLoader(true);
      const singleCaseRes = await listSingleCase(caseRes.CaseScheduleID);
      setLoader(false);
      const newData = Object.keys(caseRes).length > 0
        && caseRes.ACMSelectedParts !== null ? caseRes.ACMSelectedParts.split(';') : null;
      const { message, status, data } = singleCaseRes;
      if (status) {
        const oldData = data !== undefined && data[0].ACMSelectedParts !== null ? data[0].ACMSelectedParts.split(';') : null;
        if (JSON.stringify(newData) === JSON.stringify(oldData)) {
          this.setState({
            saveEnable: ''
          });
        } else {
          this.setState({
            saveEnable: 'Save'
          });
        }
      } else {
        notify({ type: 'error', message });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getById = async () => {
    try {
      const {
        params: { id }, tableName, online
      } = this.props;
      if (online) {
        const caseResponse = await getTableCaseByCaseId(id, tableName);
        // console.log(caseRes);
        this.setState({
          caseData: caseResponse,
          caseRes: caseResponse
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const {
        params: { id }
      } = this.props;
      if (id) {
        await this._getById();
      }
      await this._getAMCPlannedParts();
      await this._getACMSelectedParts();
      await this._onSaveEnable();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      isPlannedSelect, plannedData, selectedData, caseRes,
      selectedProduct, saveEnable, caseData: { ACMCaseFlags }
    } = this.state;

    _.remove(selectedData, (detail) => (_.isEmpty(detail.productId)
      && _.isEmpty(detail.ProductDescription)));
    return (
      <section className="list-section resizer-class">
        <Header
          title="ACM Product"
          actionButton={(caseRes.DGR === '0' && moment(caseRes.CaseDate) >= moment())
            && { type: 'button', title: saveEnable, onClick: this._onClickSave }}
          goBack={this._onACMProductGoBack}
        />
        <section className="sets-section">
          <div className="container">
            <div className="top-block">
              {(ACMCaseFlags !== null && ACMCaseFlags !== undefined && ACMCaseFlags !== '')
                ? (
                  <div className=" text-center acm-flag mb-2">
                    <button
                      type="button" className="btn btn-acm-alt"
                      onClick={this._onAcmFlagDetails}
                    >
                      *** ACM Flag ***
                    </button>
                  </div>
                )
                : ''}
              {
                caseRes.ACMAIVersion === 'GENERIC'
                && (
                  <div className="text-center acm-flag-calibrate mb-2">
                    <button type="button" className="btn btn-acm-calibrate mb-2">*** Al is not calibrated ***</button>
                  </div>
                )
              }

              <div className="row gx-2">
                <div className="col-8">
                  <div className="btn-group w-100" role="group">
                    <button onClick={() => this.setState({ isPlannedSelect: true })} type="button" className={`btn btn-theme-alt btn-theme-outline-alt w-50 ${isPlannedSelect && 'active'}`}>Planned</button>
                    <button onClick={() => this.setState({ isPlannedSelect: false })} type="button" className={`btn btn-theme-alt btn-theme-outline-alt w-50 ${!isPlannedSelect && 'active'}`}>Selected</button>
                  </div>
                </div>
                <div className="col-auto align-self-center">
                  <div className="col-4 ms-5">
                    <span className="mb-0">Selected:</span>
                    <span className="ms-1">
                      {selectedData.length}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {
              isPlannedSelect
                ? (
                  <Planned
                    data={plannedData}
                    caseDate={caseRes.CaseDate}
                    onAddSelectedProduct={this._onAddSelectedProduct}
                  />
                )
                : <Selected data={selectedData} caseData={caseRes} onDelete={this._onDelete} />
            }
          </div>
        </section>

        <section className="sets-footer-section fixed-bottom">
          <div className="container">
            <div className="button-block">
              <div className="row gx-2">
                <div className="col text-center">
                  {
                    moment(caseRes.CaseDate) >= moment()
                      ? (
                        <button
                          type="button"
                          className="btn btn-sm btn-theme-alt btn-theme-outline-alt"
                          onClick={this._onSelectProducts}
                        >
                          Select Products
                        </button>
                      ) : ''
                  }
                </div>
              </div>
            </div>
          </div>
        </section>
        <SelectProduct
          acmProduct
          product={selectedProduct}
          onCancel={() => {
            this.setState({ selectedProduct: {} });
          }}
          onSave={this._onSave}
          caseRes={caseRes}
        />
        <ACMProductGoBackModal onSave={this._onClickSave} onCancel={this._onCancel} />
        <ACMSelectedProduct />
      </section>
    );
  }
}

export default withTableName(
  withNotify(
    withLoader(
      withOnline(
        withGoBack(
          AcmProducts
        )
      )
    )
  )
);
